import { validateDecimal, validateDecimalOrEmpty, validateIntegerOrEmpty } from "../../../../../utils/validation"

const getShopIdError = (shopIdValue) => {
  if (!shopIdValue) {
    return "店舗を選択してください。"
  }
  return ""
}

const getProductIdError = (productIdValue) => {
  if (!productIdValue) {
    return "商品を選択してください。"
  }
  return ""
}

const getOriginIdError = (originIdValue) => {
  if (!originIdValue) {
    return "産地を選択してください。"
  }
  return ""
}

const getWeightError = (weightValue, weightUnitIdValue) => {

  if (weightUnitIdValue && !weightValue) {
    return "重量を入力してください。"
  }  
  if (weightValue && !validateDecimalOrEmpty(weightValue?.toString() || '')) {
    return "有効な数値を入力してください。"
  }
  if (weightValue && !weightUnitIdValue) {
    return "重量単位を選択してください。"
  }
  return ""
}

const getOrderQuantityError = (quantityValue) => {
  if (!quantityValue) {
    return "数量を入力してください。"
  }
  if (!validateDecimal(quantityValue.toString())) {
    return "有効な数値を入力してください。"
  }
  return ""
}

const getPriceError = (priceValue) => {
  if (!validateIntegerOrEmpty(priceValue?.toString() || '')) {
    return "有効な整数を入力してください。"
  }
  return ""
}

export const VALIDATION_KEYS = [
    {
      errorKeyName: "shopId",
      getError: (values) => getShopIdError(values.shopId),
      propsOnChange: ["shopId"]
    },
    {
      errorKeyName: "productId",
      getError: (values) => getProductIdError(values.productId),
      propsOnChange: ["productId"]
    },
    {
      errorKeyName: "originId",
      getError: (values) => getOriginIdError(values.originId),
      propsOnChange: ["originId"]
    },
    {
      errorKeyName: "rankId",
      getError: () => "",
      propsOnChange: ["rankId"]
    },
    {
      errorKeyName: "productClassId",
      getError: () => "",
      propsOnChange: ["productClassId"]
    },
    {
      errorKeyName: "packingId",
      getError: () => "",
      propsOnChange: ["packingId"]
    },
    {
      errorKeyName: "weight",
      getError: (values) => getWeightError(values.weight, values.weightUnitId),
      propsOnChange: ["weight", "weightUnitId"]
    },
    {
      errorKeyName: "price",
      getError: (values) => getPriceError(values.price),
      propsOnChange: ["price"]
    },
    {
      errorKeyName: "orderQuantity",
      getError: (values) => getOrderQuantityError(values.orderQuantity),
      propsOnChange: ['orderQuantity']
    }
  ];
 
